export const casesColors = [
  '#FFFBDC',
  '#FFEDB8',
  '#FFDD94',
  '#FBBF69',
  '#F5A057',
  '#ED6942',
  '#D73534',
  '#BF1B3E',
  '#952742',
  '#641A2C',
]

export const deathsColors = [
  // '#e1f6f8',
  '#c9dee0',
  // '#b2c4c6',
  '#a0b0b1',
  // '#8c999a',
  '#757f80',
  // '#646c6c',
  '#4d5353',
  // '#3a3d3d',
  '#272828',
]
